(function () {
  'use strict';
 
  if (window.UnifiedSchema) {
    return;
  }
 
  const VERSION = '1.2.0';
 
  const FIELD_TYPES = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    OBJECT: 'object',
    ARRAY: 'array'
  };
 
  const NORMALIZERS = {
    TRIM: 'trim',
    LOWERCASE: 'lowercase',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    PHONE: 'phone',
    EMAIL: 'email'
  };
 
  const coreFields = {
    ut_session_id: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    page_sequence: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 1
    },
    page_location: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_standard',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    page_path: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_standard',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    page_title: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_standard',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    page_language: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    page_loaded_at: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    time_since_page_load: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    seconds_since_page_load: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    scroll_depth: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0,
      maximum: 100
    },
    referrer_domain: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    navigation_type: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    event_timestamp: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    event_category: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    service: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    conversion_candidate: {
      type: FIELD_TYPES.BOOLEAN,
      required: true,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.BOOLEAN
      ]
    },
    origin: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    source_event: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    source_timestamp: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    page_type: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    page_subtype: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    journey_area: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    template_name: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    collection_handle: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    article_handle: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    source_section: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    source_component: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    source_mechanism: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    interaction_type: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    product_id: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'future_warehouse',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    variant_id: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    product_sku: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    product_handle: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    product_type: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    vendor: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    price: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    wine_type: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    winery: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    range: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    grape: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    country: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    region: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    wine_style: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    body: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    taste_profile: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    destination: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    value_tier: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    vivino_score: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    awards_count: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    item_class: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    commercial_product: {
      type: FIELD_TYPES.BOOLEAN,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.BOOLEAN
      ]
    },
    first_meaningful_source: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    last_meaningful_source: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    last_product_sku: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    last_product_source: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    recommendation_source: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    }
  };

  const sharedFields = {
    section_name: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    section_index: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    section_id: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    section_type: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    section_source: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    section_selector: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    visibility_ratio: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0,
      maximum: 1
    },
    visible_ms: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    phone_number: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'excluded_sensitive',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.PHONE
      ]
    },
    link_text: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    link_url: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'excluded_sensitive',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    click_location: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    cta_label: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    email_address: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'excluded_sensitive',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.EMAIL
      ]
    },
    email_domain: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    section_class: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'internal',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    has_phone: {
      type: FIELD_TYPES.BOOLEAN,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.BOOLEAN
      ]
    },
    has_email: {
      type: FIELD_TYPES.BOOLEAN,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.BOOLEAN
      ]
    },
    has_pet_name: {
      type: FIELD_TYPES.BOOLEAN,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.BOOLEAN
      ]
    },
    message_length: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    form_location: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    choice_dimension: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    choice_value: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    step_index: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    search_term_length: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    result_count: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    best_match_sku: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    sommelier_style: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    sommelier_body: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    sommelier_taste: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    recommendation_profile: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    recommendation_rank: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 1
    },
    close_method: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    bundle_type: {
      type: FIELD_TYPES.STRING,
      required: true,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM,
        NORMALIZERS.LOWERCASE
      ]
    },
    bundle_size: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 1
    },
    items_selected: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    items_remaining: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    product_position: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    product_quantity: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    bundle_value: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    progress_percent: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0,
      maximum: 100
    },
    product_name: {
      type: FIELD_TYPES.STRING,
      required: false,
      analytics: 'ga4_dimension',
      normalize: [
        NORMALIZERS.TRIM
      ]
    },
    requested_quantity: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    added_quantity: {
      type: FIELD_TYPES.NUMBER,
      required: true,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    },
    blocked_quantity: {
      type: FIELD_TYPES.NUMBER,
      required: false,
      analytics: 'ga4_metric',
      normalize: [
        NORMALIZERS.NUMBER
      ],
      minimum: 0
    }
  };

  function selectFields(fieldNames) {
    const result = {};

    (fieldNames || []).forEach(function (fieldName) {
      if (sharedFields[fieldName]) {
        result[fieldName] = sharedFields[fieldName];
      }
    });

    return result;
  }

  const eventSchemas = {
    section_view: {
      category: 'engagement',
      required: [
        'section_name',
        'section_index',
        'visibility_ratio'
      ],
      optional: [
        'section_id',
        'section_type',
        'section_source',
        'section_selector',
        'visible_ms'
      ],
      fields: selectFields(['section_name', 'section_index', 'section_id', 'section_type', 'section_source', 'section_selector', 'visibility_ratio', 'visible_ms'])
    },
    phone_grooming: {
      category: 'lead',
      required: [
        'phone_number',
        'click_location'
      ],
      optional: [
        'link_text',
        'link_url',
        'cta_label',
        'section_name'
      ],
      fields: selectFields(['phone_number', 'link_text', 'link_url', 'click_location', 'cta_label', 'section_name'])
    },
    phone_hotel: {
      inherit: 'phone_grooming',
      category: 'lead'
    },
    phone_veterinar: {
      inherit: 'phone_grooming',
      category: 'lead'
    },
    email_hotel: {
      category: 'lead',
      required: [
        'click_location'
      ],
      optional: [
        'email_address',
        'email_domain',
        'link_text',
        'link_url',
        'cta_label',
        'section_name',
        'section_class'
      ],
      fields: selectFields(['email_address', 'email_domain', 'link_text', 'link_url', 'click_location', 'cta_label', 'section_name', 'section_class'])
    },
    contact_form_submit: {
      category: 'lead',
      required: [
        'has_phone',
        'has_email',
        'message_length'
      ],
      optional: [
        'has_pet_name',
        'form_location',
        'section_name'
      ],
      fields: selectFields(['has_phone', 'has_email', 'has_pet_name', 'message_length', 'form_location', 'section_name'])
    },
    cta_click: {
      category: 'engagement',
      required: [
        'source_section',
        'source_component'
      ],
      optional: [],
      fields: {}
    },
    navigation_click: {
      category: 'engagement',
      required: [
        'source_component'
      ],
      optional: [],
      fields: {}
    },
    product_card_click: {
      category: 'engagement',
      required: [
        'product_sku',
        'source_section'
      ],
      optional: [],
      fields: {}
    },
    accordion_open: {
      category: 'engagement',
      required: [
        'source_component'
      ],
      optional: [],
      fields: {}
    },
    selector_change: {
      category: 'engagement',
      required: [
        'choice_dimension',
        'choice_value'
      ],
      optional: [
        'step_index'
      ],
      fields: selectFields(['choice_dimension', 'choice_value', 'step_index'])
    },
    filter_change: {
      category: 'engagement',
      required: [
        'choice_dimension',
        'choice_value'
      ],
      optional: [],
      fields: selectFields(['choice_dimension', 'choice_value'])
    },
    search_submit: {
      category: 'engagement',
      required: [
        'search_term_length'
      ],
      optional: [],
      fields: selectFields(['search_term_length'])
    },
    media_interaction: {
      category: 'engagement',
      required: [
        'source_component',
        'interaction_type'
      ],
      optional: [],
      fields: {}
    },
    external_link_click: {
      category: 'engagement',
      required: [
        'source_component'
      ],
      optional: [],
      fields: {}
    },
    whatsapp_click: {
      category: 'lead',
      required: [
        'source_component'
      ],
      optional: [],
      fields: {}
    },
    sommelier_start: {
      category: 'discovery',
      required: [
        'source_section'
      ],
      optional: [],
      fields: {}
    },
    sommelier_choice: {
      category: 'discovery',
      required: [
        'choice_dimension',
        'choice_value',
        'step_index'
      ],
      optional: [],
      fields: selectFields(['choice_dimension', 'choice_value', 'step_index'])
    },
    sommelier_result: {
      category: 'discovery',
      required: [
        'result_count',
        'best_match_sku'
      ],
      optional: [
        'sommelier_style',
        'sommelier_body',
        'sommelier_taste',
        'recommendation_profile'
      ],
      fields: selectFields(['result_count', 'best_match_sku', 'sommelier_style', 'sommelier_body', 'sommelier_taste', 'recommendation_profile'])
    },
    sommelier_recommendation_click: {
      category: 'discovery',
      required: [
        'product_sku',
        'recommendation_rank',
        'recommendation_source'
      ],
      optional: [],
      fields: selectFields(['recommendation_rank'])
    },
    guidance_open: {
      category: 'decision_support',
      required: [
        'product_sku'
      ],
      optional: [],
      fields: {}
    },
    guidance_choice: {
      category: 'decision_support',
      required: [
        'choice_dimension',
        'choice_value'
      ],
      optional: [
        'step_index'
      ],
      fields: selectFields(['choice_dimension', 'choice_value', 'step_index'])
    },
    guidance_continue: {
      category: 'decision_support',
      required: [
        'product_sku',
        'destination'
      ],
      optional: [],
      fields: {}
    },
    guidance_close: {
      category: 'decision_support',
      required: [
        'close_method'
      ],
      optional: [],
      fields: selectFields(['close_method'])
    },
    bundle_start: {
      category: 'bundle',
      required: [
        'bundle_type',
        'bundle_size'
      ],
      optional: [],
      fields: selectFields(['bundle_type', 'bundle_size'])
    },
    bundle_item_add: {
      category: 'bundle',
      required: [
        'variant_id',
        'items_selected'
      ],
      optional: [
        'items_remaining',
        'product_position',
        'product_quantity',
        'bundle_value'
      ],
      fields: selectFields(['items_selected', 'items_remaining', 'product_position', 'product_quantity', 'bundle_value'])
    },
    bundle_item_remove: {
      category: 'bundle',
      required: [
        'variant_id',
        'items_selected'
      ],
      optional: [
        'items_remaining',
        'product_position',
        'product_quantity',
        'bundle_value'
      ],
      fields: selectFields(['items_selected', 'items_remaining', 'product_position', 'product_quantity', 'bundle_value'])
    },
    bundle_progress: {
      category: 'bundle',
      required: [
        'bundle_type',
        'progress_percent'
      ],
      optional: [
        'bundle_size',
        'items_selected',
        'items_remaining'
      ],
      fields: selectFields(['bundle_type', 'progress_percent', 'bundle_size', 'items_selected', 'items_remaining'])
    },
    bundle_complete: {
      category: 'bundle',
      required: [
        'bundle_type',
        'bundle_size',
        'items_selected'
      ],
      optional: [
        'bundle_value'
      ],
      fields: selectFields(['bundle_type', 'bundle_size', 'items_selected', 'bundle_value'])
    },
    bundle_abandon: {
      category: 'bundle',
      required: [
        'bundle_type',
        'items_selected'
      ],
      optional: [
        'bundle_size',
        'items_remaining',
        'bundle_value'
      ],
      fields: selectFields(['bundle_type', 'items_selected', 'bundle_size', 'items_remaining', 'bundle_value'])
    },
    stock_limit_reached: {
      category: 'commerce_friction',
      required: [
        'requested_quantity',
        'added_quantity'
      ],
      optional: [
        'blocked_quantity',
        'product_name'
      ],
      fields: selectFields(['requested_quantity', 'added_quantity', 'blocked_quantity', 'product_name'])
    }
  };

  const aliases = {
    section: 'section_name',
    sectionName: 'section_name',
    sectionIndex: 'section_index',
    sectionId: 'section_id',
    sectionType: 'section_type',
    sectionSource: 'section_source',
    sectionSelector: 'section_selector',
    visibilityRatio: 'visibility_ratio',
    visibleMs: 'visible_ms',
    clickLocation: 'click_location',
    ctaLabel: 'cta_label',
    phone: 'phone_number',
    email: 'email_address',
    messageLength: 'message_length',
    hasPhone: 'has_phone',
    hasEmail: 'has_email',
    hasPetName: 'has_pet_name',
    pageType: 'page_type',
    pageSubtype: 'page_subtype',
    journeyArea: 'journey_area',
    sourceSection: 'source_section',
    sourceComponent: 'source_component',
    sourceMechanism: 'source_mechanism',
    interactionType: 'interaction_type',
    productId: 'product_id',
    variantId: 'variant_id',
    productSku: 'product_sku',
    productHandle: 'product_handle',
    productType: 'product_type',
    wineType: 'wine_type',
    wineStyle: 'wine_style',
    tasteProfile: 'taste_profile',
    valueTier: 'value_tier',
    vivinoScore: 'vivino_score',
    awardsCount: 'awards_count',
    itemClass: 'item_class',
    commercialProduct: 'commercial_product',
    firstMeaningfulSource: 'first_meaningful_source',
    lastMeaningfulSource: 'last_meaningful_source',
    lastProductSku: 'last_product_sku',
    lastProductSource: 'last_product_source',
    recommendationSource: 'recommendation_source',
    choiceDimension: 'choice_dimension',
    choiceValue: 'choice_value',
    stepIndex: 'step_index',
    resultCount: 'result_count',
    bestMatchSku: 'best_match_sku',
    recommendationRank: 'recommendation_rank',
    closeMethod: 'close_method',
    bundleType: 'bundle_type',
    bundleSize: 'bundle_size',
    itemsSelected: 'items_selected',
    itemsRemaining: 'items_remaining',
    bundleValue: 'bundle_value',
    progressPercent: 'progress_percent',
    requestedQuantity: 'requested_quantity',
    addedQuantity: 'added_quantity',
    blockedQuantity: 'blocked_quantity'
  };

  function clone(value) {
    return JSON.parse(
      JSON.stringify(value)
    );
  }
 
  function mergeSchemas(
    baseSchema,
    childSchema
  ) {
    return {
      category:
        childSchema.category ||
        baseSchema.category ||
        '',
 
      required: Array.from(
        new Set(
          []
            .concat(
              baseSchema.required || []
            )
            .concat(
              childSchema.required || []
            )
        )
      ),
 
      optional: Array.from(
        new Set(
          []
            .concat(
              baseSchema.optional || []
            )
            .concat(
              childSchema.optional || []
            )
        )
      ),
 
      fields: Object.assign(
        {},
        baseSchema.fields || {},
        childSchema.fields || {}
      )
    };
  }
 
  function getEventSchema(
    eventName
  ) {
    const schema =
      eventSchemas[eventName];
 
    if (!schema) {
      return null;
    }
 
    if (!schema.inherit) {
      return clone(schema);
    }
 
    const parent =
      eventSchemas[
        schema.inherit
      ];
 
    if (!parent) {
      return clone(schema);
    }
 
    return mergeSchemas(
      parent,
      schema
    );
  }
 
  function getFieldDefinition(
    eventName,
    fieldName
  ) {
    if (coreFields[fieldName]) {
      return clone(
        coreFields[fieldName]
      );
    }
 
    const eventSchema =
      getEventSchema(
        eventName
      );
 
    if (
      eventSchema &&
      eventSchema.fields &&
      eventSchema.fields[fieldName]
    ) {
      return clone(
        eventSchema.fields[
          fieldName
        ]
      );
    }
 
    return null;
  }
 
  function getRequiredFields(
    eventName
  ) {
    const eventSchema =
      getEventSchema(
        eventName
      );
 
    const coreRequired =
      Object.keys(coreFields)
        .filter(
          function (fieldName) {
            return (
              coreFields[fieldName]
                .required === true
            );
          }
        );
 
    const eventRequired =
      eventSchema &&
      Array.isArray(
        eventSchema.required
      )
        ? eventSchema.required
        : [];
 
    return Array.from(
      new Set(
        coreRequired.concat(
          eventRequired
        )
      )
    );
  }
 
  function getAllowedFields(
    eventName
  ) {
    const eventSchema =
      getEventSchema(
        eventName
      );
 
    const fields =
      Object.keys(coreFields);
 
    if (
      eventSchema &&
      eventSchema.fields
    ) {
      fields.push.apply(
        fields,
        Object.keys(
          eventSchema.fields
        )
      );
    }
 
    return Array.from(
      new Set(fields)
    );
  }
 
  function getAlias(
    fieldName
  ) {
    return (
      aliases[fieldName] ||
      null
    );
  }
 
  function getAnalyticsMap(
    eventName
  ) {
    const result = {};
 
    getAllowedFields(eventName)
      .forEach(
        function (fieldName) {
          const definition =
            getFieldDefinition(
              eventName,
              fieldName
            );
 
          result[fieldName] =
            definition &&
            definition.analytics
              ? definition.analytics
              : 'unclassified';
        }
      );
 
    return result;
  }
 
  function getNormalizationRules(
    eventName,
    fieldName
  ) {
    const definition =
      getFieldDefinition(
        eventName,
        fieldName
      );
 
    if (
      !definition ||
      !Array.isArray(
        definition.normalize
      )
    ) {
      return [];
    }
 
    return clone(
      definition.normalize
    );
  }
 
  function getNormalizationMap(
    eventName
  ) {
    const result = {};
 
    getAllowedFields(eventName)
      .forEach(
        function (fieldName) {
          result[fieldName] =
            getNormalizationRules(
              eventName,
              fieldName
            );
        }
      );
 
    return result;
  }
 
  window.UnifiedSchema = {
    version:
      VERSION,
 
    types:
      FIELD_TYPES,
 
    normalizers:
      NORMALIZERS,
 
    coreFields:
      clone(coreFields),
 
    events:
      clone(eventSchemas),
 
    aliases:
      clone(aliases),
 
    getEventSchema:
      getEventSchema,
 
    getFieldDefinition:
      getFieldDefinition,
 
    getRequiredFields:
      getRequiredFields,
 
    getAllowedFields:
      getAllowedFields,
 
    getAlias:
      getAlias,
 
    getAnalyticsMap:
      getAnalyticsMap,
 
    getNormalizationRules:
      getNormalizationRules,
 
    getNormalizationMap:
      getNormalizationMap
  };
 
  if (
    window.UnifiedTrackingConfig &&
    window.UnifiedTrackingConfig.debug
  ) {
    console.info(
      '[Unified Schema] Analytics Contract initialized',
      {
        version:
          VERSION,
 
        coreFields:
          Object.keys(
            coreFields
          ).length,
 
        events:
          Object.keys(
            eventSchemas
          ).length,
 
        normalizers:
          Object.keys(
            NORMALIZERS
          ).length
      }
    );
  }
})();
